import { DEFAULT_CONFIG } from "./data/default-config";
import { createInitialEntities } from "./data/default-setup";
import type { ParticipantId } from "./types/common";
import type { InitialEntitySeed, KineticCoreConfig } from "./types/game-config";
import type { KineticCoreState, Participant } from "./types/game-state";

export interface InitMatchOptions {
  readonly participant1Id?: ParticipantId;
  readonly participant2Id?: ParticipantId;
  readonly participant1Name?: string;
  readonly participant2Name?: string;
  readonly config?: KineticCoreConfig;
  readonly initialEntities?: ReadonlyArray<InitialEntitySeed>;
}

export function initMatch(options: InitMatchOptions = {}): KineticCoreState {
  const {
    participant1Id = "P1",
    participant2Id = "P2",
    participant1Name = "Participant 1",
    participant2Name = "Participant 2",
    config = DEFAULT_CONFIG,
    initialEntities,
  } = options;

  const participants: readonly [Participant, Participant] = [
    { id: participant1Id, name: participant1Name },
    { id: participant2Id, name: participant2Name },
  ];

  return {
    phase: "RUNNING",
    turn: 1,
    currentParticipant: participants[0].id,
    participants,
    entities: createInitialEntities(
      config.archetypes,
      [participants[0].id, participants[1].id],
      initialEntities,
    ),
    winner: null,
    outcomeReason: null,
    isDraw: false,
    lastRecording: null,
  };
}
